import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Layout, Menu } from "antd";

const Header = ({ location }) => (
  <Layout.Header
    style={{
      padding: "0 0px",
      // margin: "10px"
    }}
  >
    <div styles={{margin:"10px"}}>
    <div
      style={{
        float: "left"
      }}
    >
      <h2
        style={{
          color: "#fff",          
          marginBottom: "1em",
          marginLeft: "1em",
          marginRight: "1em",
          display: "inline",
          width: 100,
          lineHeight: "54px"
        }}
      >
        Ahli Production Dashboard
      </h2>
    </div>
    <Menu
      theme="dark"
      mode="horizontal"
      selectedKeys={[location.pathname]}
      style={{
        // position: "relative",
        lineHeight: "64px",
        // marginBottom: "60px"
      }}
    >
      <Menu.Item key="/explore">
        <Link to="/explore">Explore</Link>
      </Menu.Item>
      <Menu.Item key="/">
        <Link to="/">Dashboard</Link>
      </Menu.Item>
    </Menu>

    </div>
  </Layout.Header>
);

export default withRouter(Header);
